import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/communication';

export class CommunicationService extends RestServiceConnection {
    listCommunications = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    getCommunication = async (communicationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { communicationId },
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    getPendingSummary = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/pending-summary',
        }, true) as AxiosResponse;
        return this;
    };

    createCommunication = async (data: { contractId: string; targetDepartmentId: string; message: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    replyCommunication = async (data: { communicationId: string; message: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/reply',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };
}
